import React from 'react'
import { Box, Typography, Avatar, Grid } from '@mui/material'

export default function About() {
  return (
    <Box
      sx={{
        mt: 4,
        backgroundColor: 'lightblue',
        border: '2px solid',
        borderColor: 'white',
        borderRadius: 2,
        p: 3,
      }}
    >
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Avatar
              alt="My Picture"
              src="/images/mypicture.png"
              sx={{ width: 150, height: 150 }}
            />
            <Typography variant="h5" sx={{ ml: 2 }}>
              {/* Soesanto */}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Typography variant="h4" gutterBottom>
            About Me :
          </Typography>
          <Typography variant="body1" paragraph>
            Full-stack developer with solid experience in building scalable,
            user-friendly web and mobile applications. Comfortable working in
            Agile teams and translating business needs into maintainable
            technical solutions.
          </Typography>
          <Typography variant="body1" paragraph>
            Skilled in UI frameworks like Tailwind CSS, Bootstrap, and Material
            UI, and experienced with React, React Native, Next.js, Node.js,
            Express, and Laravel. Proficient in building RESTful and GraphQL
            APIs using Java Spring Boot and Express, including secure with JWT
            authentication.
          </Typography>
          <Typography variant="body1" paragraph>
            Work comfortably with MongoDB, PostgreSQL and MySQL using Prisma,
            Sequelize, or even raw SQL when needed. Familiar with Docker,
            Vercel, Xampp, Git, and basic networking tools. Known for solving
            problems efficiently, leading by example, and contributing value in
            fast-paced environments using Scrum and Jira.
          </Typography>
          <Typography>
            Full understanding of Software Development Life Cycle (SDLC):
            requirement gathering, system design, implementation, testing,
            deployment, maintenance
          </Typography>
          <Typography variant="h4" gutterBottom sx={{ mt: 5 }}>
            Core Skills:
          </Typography>
          <Typography variant="body1">- Desktop Programming</Typography>
          <Typography variant="body1">
            - Web Development (React.js, React-Native, Next.js, Laravel,
            Node.js, Express.js)
          </Typography>
          <Typography variant="body1">
            - Accounting & POS System Development
          </Typography>
          <Typography variant="body1">
            - REST API, GraphQL, JWT Authentication 
          </Typography>
          <Typography variant="body1">
            - Database: MongoDB, MySQL and PostgreSQL 
          </Typography>
          <Typography variant="body1">
            - Time Management & Leadership
          </Typography>
          <Typography variant="body1">
            - Critical Thinking & Problem Solving
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
